import { createSlice } from "@reduxjs/toolkit";
import {
  AppState,
  addToAINotificationInterface,
  updateAINotificationIntroInterface,
  updateShowTourInterface,
  updateShowTourStartInterface,
} from "./appSlice-interface";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: AppState = {
  showTour: false,
  aiNotifications: [],
  showTourStart: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateShowTour: (state, action: PayloadAction<updateShowTourInterface>) => {
      state.showTour = action.payload.showTour;
    },
    updateShowTourStart: (
      state,
      action: PayloadAction<updateShowTourStartInterface>
    ) => {
      state.showTourStart = action.payload.showTourStart;
    },
    addToAINotification: (
      state,
      action: PayloadAction<addToAINotificationInterface>
    ) => {
      state.aiNotifications = [
        ...state.aiNotifications,
        ...action.payload.aiNotification,
      ];
    },
    updateAINotification: (
      state,
      action: PayloadAction<updateAINotificationIntroInterface>
    ) => {
      state.aiNotifications = action.payload.aiNotifications;
    },
  },
});

export const {
  updateShowTour,
  addToAINotification,
  updateAINotification,
  updateShowTourStart,
} = appSlice.actions;

const appReducer = appSlice.reducer;

export default appReducer;
